<template>
  <div class="Revenuerecord">
    <div class="title">
      <div style="margin-top:15px;">
        <label>业务经理：</label>
        <el-select v-model="promotersValue" @change="search">
          <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.roleUserName"
            :value="item.rid">
          </el-option>
        </el-select>
        <el-button type="primary" style="margin-left:15px;" @click="reset">重置</el-button>
      </div>
      <div style="margin-top:15px;">
        <el-button type="primary" @click="Add" v-if="this.str.superDepartmentName !== '商务部'||this.str.system == 4">发放</el-button>
      </div>
      <!-- <div style="width:550px;">
        <el-input placeholder="业务经理、操作员" style="width:350px;"></el-input>
        <el-button type="primary" style="margin-left:15px;">搜索</el-button>
        <el-button type="primary">重置</el-button>
      </div> -->
    </div>

    <div style="margin-top:30px;">
      <el-table :data="tableData" border style="width: 100%" v-loading="loading">
        <el-table-column prop="cycle" label="周期" align="center"></el-table-column>
        <el-table-column prop="amountIssued" label="已发放收益" align="center"></el-table-column>
        <el-table-column label="发放凭证" align="center">
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="right">
            <img :src="scope.row.issueCertificates" alt style="width:200px;height:200px;"/>
                <div class="scope_img" slot="reference">
                    <img :src="scope.row.issueCertificates" alt style="width:55px;heigth:55px;" />
                </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="promoterRoleUserName" label="业务经理" align="center"></el-table-column>
        <el-table-column prop="issuanceTime" label="发放时间" align="center"></el-table-column>
        <el-table-column prop="operatorRoleUserName" label="操作员" align="center"></el-table-column>
      </el-table>
    </div>
    <div class="page">
        <el-pagination
            style="margin-right:200px;"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[20, 100, 200, 400]"
            :page-size="pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
        ></el-pagination>
    </div>


    <el-dialog title="发放收益" :visible.sync="dividend" width="40%">
            <el-form :model="form" class="dividendForm">
                <el-form-item label="业务经理：" :label-width="formLabelWidth">
                    <el-select placeholder="选择业务经理" style="width:485px;" v-model="InpromotersValue" @change="selectEvent($event)" v-if="this.str.system == 4">
                      <el-option
                        v-for="item in options1"
                        :key="item.id"
                        :label="item.roleUserName"
                        :value="item">
                      </el-option>
                    </el-select>
                    <el-select placeholder="选择业务经理" style="width:485px;" v-model="InpromotersValue" @change="selectEvent($event)" v-if="this.str.system !== 4">
                      <el-option
                        v-for="item in options"
                        :key="item.id"
                        :label="item.roleUserName"
                        :value="item">
                      </el-option>
                    </el-select>
                </el-form-item>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="发放账户：" :label-width="formLabelWidth">
                        <span v-if="this.issues!==null">{{this.issues.bank}}</span>
                        <span v-if="this.issues==null">暂无</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="发放户名：" :label-width="formLabelWidth">
                        <span v-if="this.issues!==null">{{this.issues.accountName}}</span>
                        <span v-if="this.issues==null">暂无</span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="发放账号：" :label-width="formLabelWidth">
                        <span v-if="this.issues!==null">{{this.issues.accountNumber}}</span>
                        <span v-if="this.issues==null">暂无</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="发放银行：" :label-width="formLabelWidth">
                        <span v-if="this.issues!==null">{{this.issues.accountOpeningBranch}}</span>
                        <span v-if="this.issues==null">暂无</span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-form-item label="发放周期：" :label-width="formLabelWidth">
                  <el-row>
                    <el-col :span="10">
                          <el-form-item label="开始日期" prop="starttime">
                              <el-date-picker
                                      class="width1"
                                      v-model="ruleForm.starttime"
                                      type="date"
                                      placeholder="选择开始日期"
                                      @change="startDate"
                              ></el-date-picker>
                          </el-form-item>
                    </el-col>
                    <el-col :span="10">
                          <el-form-item label="结束日期" prop="Jieshutime">
                              <el-date-picker
                                      class="width1"
                                      v-model="ruleForm.endtime"
                                      type="date"
                                      placeholder="选择结束日期"
                                      @change="endDate"
                              ></el-date-picker>
                          </el-form-item>
                      </el-col>
                  </el-row>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="QueryReturns">查询</el-button>
                </el-form-item>
                  
                <el-form-item label="推广总收益：" style="margin-top:15px;">
                  <span>{{this.totalPromotionRevenue}}</span>
                </el-form-item>
                <el-form-item label="发放凭证：" :label-width="formLabelWidth">
                    <div>
                        <el-upload
                            ref='upload'
                            class="avatar-uploader"
                            :action="action"
                            :show-file-list="false"
                            :on-success="handleAvatarSuccess"
                            :headers="customHeaders"
                            >
                        <img v-if="imageUrl" :src="imageUrl" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                    </div>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取消</el-button>
                <el-button type="primary" @click="issue">提交</el-button>
            </div>

            <el-dialog width="60%" title="查询收益" :visible.sync="innerVisible" append-to-body>
                <el-table :data="intableData" border style="width: 100%" v-loading="loading1">
                    <el-table-column prop="amazonOrderId" label="订单号" align="center"></el-table-column>
                    <el-table-column prop="platformFee" label="平台费" align="center"></el-table-column>
                    <el-table-column prop="promotionRatio" label="推广比例" align="center"></el-table-column>
                    <el-table-column prop="promotionFee" label="推广收益" align="center"></el-table-column>
                    <el-table-column prop="companyFullName" label="推广公司" align="center"></el-table-column>
                    <el-table-column prop="recordTime" label="收益时间" align="center"></el-table-column>
                  </el-table>
                <div style="margin-top:20px;">
                  推广总收益：{{this.totalPromotionRevenue}}
                </div>
                <div class="page1">
                <el-pagination
                    @size-change="handleSizeChange1"
                    @current-change="handleCurrentChange1"
                    :current-page="currentPage1"
                    :page-sizes="[20, 100, 200, 400]"
                    :page-size="pagesize1"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total1"
                ></el-pagination>
            </div>
            </el-dialog>
    </el-dialog>


  </div>
</template>

<script>
import { ajaxPost, Baseurl } from "../../api/api/api";
export default {
    name: "Promotionrevenue",
    data() {
        return {
            tableData:[],
            intableData:[],
            options:[],
            options1:[],
            promotersValue:"",
            InpromotersValue:"",
            formLabelWidth: "90px",
            issues:"",
            promotersRid:"",
            totalPromotionRevenue:"",
            ruleForm: {
                starttime: "", //开始时间
                endtime: "", //结束时间
            },
            form:{
              bank:"",
              accountOpeningBranch:"",
              accountName:"",
              accountNumber:""
            },
            action: Baseurl + "imageController/uploadImage",
            customHeaders: { token: localStorage.getItem("token") },
            imageUrl: '',
            dividend:false,
            innerVisible:false,
            loading:true,
            loading1:true,

            currentPage: 1,
            pagesize: 20,
            size: 20,
            total: 0,

            currentPage1: 1,
            pagesize1: 20,
            size1: 20,
            total1: 0,
        };
    },
    created() {
        this.str = JSON.parse(localStorage.getItem("role"));
        this.promoters()
        this.search()
    },
    methods: {
      search(){
        this.loading = true
        var obj = {
            promoterRid:this.promotersValue,
            page:this.currentPage,
            size:this.size,
            signRid:this.str.rid
        }
        ajaxPost(Baseurl + "issuanceRecordController/selectIssuanceRecord",obj).then(res => {
            if(res.data.code == 200){
                this.tableData = res.data.data.list
                this.total = res.data.data.total
            }else{
                this.$message.error(res.data.data);
            }
            this.loading = false
        });
      },
      Add(){
        this.dividend = true
        if(this.str.system == 4){
          this.promoters1()
        }else{
          this.promoters()
        }
      },
      promoters1(){
        var obj = {
          signRid:this.str.rid,
          companyId:this.str.company_id
        }
          var url = "issuanceRecordController/selectPromoterList1"
        
        ajaxPost(Baseurl + url,obj).then(res => {
            if(res.data.code == 200){
                this.options1 = res.data.data
                // console.log(res.data.data)
            }else{
                this.$message.error(res.data.data);
            }
        });
      },
      promoters(){
        var obj = {
          signRid:this.str.rid,
          companyId:this.str.company_id
        }
          var url = "issuanceRecordController/selectPromoterList"
        
        ajaxPost(Baseurl + url,obj).then(res => {
            if(res.data.code == 200){
                this.options = res.data.data
                // console.log(res.data.data)
            }else{
                this.$message.error(res.data.data);
            }
        });
      },
      reset(){
        this.promotersValue = ""
        this.search()
      },
      selectEvent(val){
        this.issues = val.remittanceAccount
        this.promotersRid = val.rid
      },
      QueryReturns(){
        if(this.promotersRid == ""){
          this.$message.error("请选择业务经理")
        }else{
          this.innerVisible = true
          this.QueryAjax()
        }
      },
      QueryAjax(){
        this.loading1 = true
        var obj = {
              rid:this.promotersRid,
              startTime:this.ruleForm.starttime,
              endTime:this.ruleForm.endtime,
              page:this.currentPage1,
              size:this.size1
          }
          ajaxPost(Baseurl + "promotionRevenueRecordController/selectPromotionRevenueRecord",obj).then(res => {
              if(res.data.code == 200){
                  this.intableData = res.data.data.promotionRevenues.list
                  this.total1 = res.data.data.promotionRevenues.total
                  this.totalPromotionRevenue = res.data.data.totalPromotionRevenue
              }else{
                  this.$message.error(res.data.data);
              }
              this.loading1 = false
          });
      },
      handleAvatarSuccess(res, file) {
          this.imageUrl = res.data;
      },
      issue(){
        if(this.promotersRid == ""){
          this.$message.error("请选择业务经理")
        }else if(this.totalPromotionRevenue == ""){
          this.$message.error("请查询推广总收益")
        }else if(this.imageUrl == ""){
          this.$message.error("请上传发放凭证")
        }else if(this.ruleForm.starttime == ""){
          this.$message.error("请选择开始日期")
        }else if(this.ruleForm.endtime == ""){
          this.$message.error("请选择结束日期")
        }else{
            var obj = {
              amountIssued:this.totalPromotionRevenue,
              issueCertificates:this.imageUrl,
              promoterRid:this.promotersRid,
              operatorRid:this.str.rid,
              bank:this.issues.bank,
              accountOpeningBranch:this.issues.accountOpeningBranch,
              accountName:this.issues.accountName,
              accountNumber:this.issues.accountNumber,
              startTime:this.ruleForm.starttime,
              endTime:this.ruleForm.endtime,
            }
            ajaxPost(Baseurl + "issuanceRecordController/insertIssuanceRecord",obj).then(res => {
                if(res.data.code == 200){
                    this.$message({
                      type:"success",
                      message:"提交成功"
                    })
                    this.search()
                }else{
                    this.$message.error(res.data.data);
                }
                this.dividend = false;
                this.dividend = false
                this.InpromotersValue = ""
                this.issues = ""
                this.ruleForm.starttime = ""
                this.ruleForm.endtime = ""
                this.totalPromotionRevenue = ""
                this.imageUrl = ""
                this.promotersRid == ""
            });
        }
      },
      cancel(){
        this.dividend = false
        this.InpromotersValue = ""
        this.issues = ""
        this.promotersRid = ""
        this.ruleForm.starttime = ""
        this.ruleForm.endtime = ""
        this.totalPromotionRevenue = ""
        this.imageUrl = ""
      },
      //选择开始日期
        startDate(val) {
            var d = new Date(val);
            var datetime =
                d.getFullYear() +
                "-" +
                (d.getMonth() + 1) +
                "-" +
                d.getDate() +
                " 00:00:00";
            this.ruleForm.starttime = datetime;
        },
        //选择结束日期
        endDate(val) {
            var d = new Date(val);
            var datetime =
                d.getFullYear() +
                "-" +
                (d.getMonth() + 1) +
                "-" +
                d.getDate() +
                " 23:59:59";
            this.ruleForm.endtime = datetime;
        },
        handleSizeChange(val) {
            // console.log(`每页 ${val} 条`);
            this.size = val;
            this.search();
        },
        handleCurrentChange(val) {
            // console.log(`当前页: ${val}`);
            this.currentPage = val;
            this.search();
        },
        handleSizeChange1(val) {
            // console.log(`每页 ${val} 条`);
            this.size1 = val;
            this.QueryAjax();
        },
        handleCurrentChange1(val) {
            // console.log(`当前页: ${val}`);
            this.currentPage1 = val;
            this.QueryAjax();
        },
    }
}
</script>

<style lang="scss" scoped>
/deep/ {
    .dividendForm .el-form-item__label{
      text-align: left;
    }
    .el-dialog__body{
          padding: 30px 35px;
    }
    .dividendForm .el-form-item{
          margin-bottom: 0px;
    }
    .dividendForm .width1{
          width: 66% !important;
    }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }

}
.page {
      position: fixed;
      width: 100%;
      bottom: 0;
      background-color: white;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 50px;
}
.page1 {
      width: 100%;
      bottom: 0;
      background-color: white;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 50px;
}
</style>